const SUPPORTED_URL_PROTOCOLS = new Set(['https:', 'mailto:', 'sms:', 'tel:']);

export function sanitizeUrl(url: string): string {
  if (!validateURL(url)) {
    return 'about:blank';
  }
  return url;
}
export function validateURL(url: string): boolean {
  try {
    const parsedUrl = new URL(url);
    return SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol);
  } catch {
    return false;
  }
}
